import { EmptyModelData } from "./../statecharts/ModelData";
import { StatechartsService } from "../statecharts/statecharts-service";
import { ModelData } from "../statecharts/ModelData";

export interface RecentFile {
  modelId: string;
  model: ModelData;
  lastModified: Date;
}

export const EmptyRecentFile = {
  modelId: null,
  model: EmptyModelData,
  lastModified: null,
};

export default class RecentItemsService {
  constructor(private cloudStatechartService: StatechartsService) {}

  public async getRecentFilesList(
    waitForDirtyState = true,
    abortable = false
  ): Promise<{
    lastFive: RecentFile[];
    all: RecentFile[];
  }> {
    const list: RecentFile[] = await this.cloudStatechartService.getModels(abortable, waitForDirtyState).then((res) => {
      return res.map((el) => ({
        modelId: el.id,
        model: el,
        lastModified: el.modifiedAt,
      }));
    });

    return { lastFive: list.slice(0, 5), all: list };
  }
}
